<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card v-if="masterObject && surveysList">
          <h1 class="mb-3">
            جزئیات نظرسنجی
            <b-link :to="`/users/${masterObject.userId}`">
              {{ masterObject.fullName }}
            </b-link>
          </h1>
          <b-row>
            <b-col cols="12" v-if="surveysList">
              <b-table
                :items="surveysList"
                :fields="surveyListHeader"
                head-variant="light"
              >
                <template #cell(actions)="row">
                  <b-button
                    @click="row.toggleDetails()"
                    variant="success"
                    size="sm"
                    >جزئیات</b-button
                  >
                </template>

                <template v-slot:row-details="row">
                  <b-table
                    :items="row.item.surveyResult"
                    :fields="surveyQuestionFields"
                  >
                    <template #cell(userName)="row">
                      {{ row.item }}
                    </template>
                    <template #cell(actions)="data">
                      <b-button
                        variant="transparent"
                        @click="
                          renderQuestionRateModal(
                            data.item.questionId,
                            row.item.surveyId
                          )
                        "
                      >
                        <feather-icon
                          icon="ExternalLinkIcon"
                          size="20"
                          class="text-primary"
                        />
                      </b-button>
                    </template>
                  </b-table>
                  <b-card
                    bg-variant="light"
                    header="نظر زبان آموز"
                    class="text-center"
                  >
                    <b-card-text>
                      {{
                        row.item.surveyDescription
                          ? row.item.surveyDescription
                          : "-"
                      }}
                    </b-card-text>
                  </b-card>
                </template>
              </b-table>
            </b-col>
            <b-col cols="12" v-else>
              <p class="text-center my-2" style="font-weight: bold">
                هیچ نظرسنجی جهت نمایش وجود ندارد.
              </p>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <question-rate-modal
      :surveyId="tempSurveyId"
      :questionId="tempQuestionId"
    ></question-rate-modal>
  </b-overlay>
</template>
<script>
export default {
  mounted() {
    this.getMasterLite();
    this.getMasterSuyrveyDetails();
  },
  data() {
    return {
      isLoading: false,
      masterObject: null,
      surveysList: null,
      surveyListHeader: [
        {
          key: "surveyName",
          label: "نام نظر سنجی",
        },
        {
          key: "userName",
          label: "زبان آموز",
        },
        {
          key: "actions",
          label: "دیدن جزئیات",
        },
      ],
      surveyQuestionFields: [
        {
          key: "question",
          label: "سوال",
        },
        {
          key: "response",
          label: "جواب",
        },
        {
          key: "responseValue",
          label: "نمره‌ی جواب",
        },
        {
          key: "actions",
          label: "میانگین بر اساس این سوال",
        },
      ],
      tempQuestionId: null,
      tempSurveyId: null,
    };
  },
  methods: {
    renderQuestionRateModal(questionId, surveyId) {
      this.tempQuestionId = questionId;
      this.tempSurveyId = surveyId;
      this.$bvModal.show("question-rate-modal");
    },
    async getMasterLite() {
      try {
        this.isLoading = true;
        let _this = this;
        let getLiteUserById = new GetLiteUserById(_this);
        getLiteUserById.setRequestParam({ id: _this.$route.params.masterId });
        await getLiteUserById.fetch((res) => {
          _this.masterObject = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getMasterSuyrveyDetails() {
      try {
        this.isLoading = true;
        let _this = this;
        let getReportsOfSurveysByMaster = new GetReportsOfSurveysByMaster(
          _this
        );
        getReportsOfSurveysByMaster.setRequestParam({
          MasterId: _this.$route.params.masterId,
          surveyId: _this.$route.params.surveyId,
        });
        await getReportsOfSurveysByMaster.fetch((res) => {
          _this.surveysList = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BContainer,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BBadge,
    BPagination,
    BOverlay,
    QuestionRateModal,
  },
};
import {
  BContainer,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BLink,
  BBadge,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import QuestionRateModal from "@/views/components/Survey/QuestionRateModal.vue";
import { GetReportsOfSurveysByMaster } from "@/libs/Api/SuveyUserSurvey";
import { GetLiteUserById } from "@/libs/Api/Users";
</script>
